module.exports = __webpack_public_path__ + "static/media/map_pl.dcaf398d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/maps/map_pl.svg
// module id = 1323
// module chunks = 0